module.exports = __webpack_public_path__ + "static/media/intro_order_online.d5cdc8c8.png";